/**
 * Date utility functions for week calculations
 * Kept as-is from original - well tested, works correctly
 */

export function getMonday(date = new Date()) {
  const d = new Date(date);
  const day = d.getDay();
  const diff = d.getDate() - day + (day === 0 ? -6 : 1);
  return new Date(d.setDate(diff));
}

export function getWeekStart(date = new Date()) {
  return formatDate(getMonday(date));
}

export function formatDate(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function parseDate(dateStr) {
  return new Date(dateStr + 'T00:00:00');
}

export function getWeekLabel(weekStart) {
  const date = parseDate(weekStart);
  const options = { month: 'short', day: 'numeric' };
  return `Week of ${date.toLocaleDateString('en-US', options)}`;
}

export function getPreviousWeek(weekStart) {
  const date = parseDate(weekStart);
  date.setDate(date.getDate() - 7);
  return formatDate(date);
}

export function getNextWeek(weekStart) {
  const date = parseDate(weekStart);
  date.setDate(date.getDate() + 7);
  return formatDate(date);
}

export function getDaysOfWeek() {
  return ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
}

export function getDayLabel(day) {
  return day.charAt(0).toUpperCase() + day.slice(1);
}

export function isCurrentWeek(weekStart) {
  return weekStart === getWeekStart();
}
